import { registerTicketView } from "@shared/components/tickets/ticketViewRegistry";
import SFWTicketView from "./components/SFWTicketView.vue";

registerTicketView({
  twinTypePattern: "sfw.ticket.production*",
  component: SFWTicketView,
});
